// extracted by mini-css-extract-plugin
module.exports = {"commentsAction":"BusinessInfo_commentsAction__13kvn","messageIcon":"BusinessInfo_messageIcon__10XDL","commentText":"BusinessInfo_commentText__2cHFd"};